/* Mighty Nighties Theme - Main JavaScript */
/* mightynighties.store */

'use strict';

// ===================== HERO SLIDESHOW =====================
class HeroSlideshow {
  constructor(el) {
    this.el = el;
    this.track = el.querySelector('.hero-slideshow__track');
    this.slides = el.querySelectorAll('.hero-slide');
    this.dots = el.querySelectorAll('.hero-slideshow__dot');
    this.prevBtn = el.querySelector('.hero-slideshow__prev');
    this.nextBtn = el.querySelector('.hero-slideshow__next');
    this.current = 0;
    this.total = this.slides.length;
    this.autoplayInterval = null;
    this.autoplayDelay = parseInt(el.dataset.autoplay) || 5000;
    if (this.total < 2) return;
    this.init();
  }

  init() {
    this.prevBtn?.addEventListener('click', () => this.prev());
    this.nextBtn?.addEventListener('click', () => this.next());
    this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.goTo(i)));
    this.startAutoplay();
    this.el.addEventListener('mouseenter', () => this.stopAutoplay());
    this.el.addEventListener('mouseleave', () => this.startAutoplay());
    let startX = 0;
    this.track.addEventListener('touchstart', e => { startX = e.touches[0].clientX; }, { passive: true });
    this.track.addEventListener('touchend', e => {
      const diff = startX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 50) diff > 0 ? this.next() : this.prev();
    });
  }

  goTo(index) {
    this.current = (index + this.total) % this.total;
    this.track.style.transform = `translateX(-${this.current * 100}%)`;
    this.dots.forEach((d, i) => d.classList.toggle('is-active', i === this.current));
  }

  next() { this.goTo(this.current + 1); }
  prev() { this.goTo(this.current - 1); }
  startAutoplay() { this.stopAutoplay(); this.autoplayInterval = setInterval(() => this.next(), this.autoplayDelay); }
  stopAutoplay() { clearInterval(this.autoplayInterval); }
}

// ===================== ANNOUNCEMENT BAR =====================
function initAnnouncementBar() {
  const bar = document.querySelector('.announcement-bar');
  if (!bar) return;
  const track = bar.querySelector('.announcement-bar__track');
  if (!track) return;
  track.innerHTML += track.innerHTML;
}

// ===================== HEADER SEARCH =====================
function initSearch() {
  const btn = document.querySelector('.header-search-btn');
  const panel = document.querySelector('.search-panel');
  const input = panel?.querySelector('.search-panel__input');
  if (!btn || !panel) return;
  btn.addEventListener('click', (e) => {
    e.stopPropagation();
    const open = panel.classList.toggle('is-open');
    if (open) { setTimeout(() => input?.focus(), 100); }
  });
  document.addEventListener('click', (e) => {
    if (!panel.contains(e.target) && !btn.contains(e.target)) panel.classList.remove('is-open');
  });
  panel.addEventListener('keydown', e => { if (e.key === 'Escape') panel.classList.remove('is-open'); });
}

// ===================== MOBILE MENU =====================
function initMobileMenu() {
  const menuBtn = document.querySelector('.mobile-menu-btn');
  const menu = document.querySelector('.mobile-menu');
  const overlay = document.querySelector('.mobile-menu-overlay');
  const closeBtn = document.querySelector('.mobile-menu__close');
  if (!menuBtn || !menu) return;
  function open() { menu.classList.add('is-open'); overlay?.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
  function close() { menu.classList.remove('is-open'); overlay?.classList.remove('is-open'); document.body.style.overflow = ''; }
  menuBtn.addEventListener('click', open);
  closeBtn?.addEventListener('click', close);
  overlay?.addEventListener('click', close);
  document.querySelectorAll('.mobile-nav-toggle').forEach(toggle => {
    toggle.addEventListener('click', () => {
      const submenu = toggle.closest('.mobile-nav-item')?.querySelector('.mobile-submenu');
      if (!submenu) return;
      const isOpen = submenu.classList.toggle('is-open');
      toggle.querySelector('.toggle-icon')?.classList.toggle('rotated', isOpen);
    });
  });
}

// ===================== CART DRAWER =====================
class CartDrawer {
  constructor() {
    this.drawer = document.querySelector('.cart-drawer');
    this.overlay = document.querySelector('.cart-drawer-overlay');
    this.closeBtn = document.querySelector('.cart-drawer__close');
    this.openBtns = document.querySelectorAll('.cart-icon-btn');
    this.countEls = document.querySelectorAll('.cart-count');
    this.FREE_THRESHOLD = 600000;
    this.init();
  }

  init() {
    this.openBtns.forEach(btn => btn.addEventListener('click', e => { e.preventDefault(); this.open(); }));
    this.closeBtn?.addEventListener('click', () => this.close());
    this.overlay?.addEventListener('click', () => this.close());

    const isTouchDevice = 'ontouchstart' in window;
    const eventName = isTouchDevice ? 'touchend' : 'click';

    document.addEventListener(eventName, async e => {
      const buyNowBtn = e.target.closest('.product-card__buynow-bar');
      if (buyNowBtn) {
        e.preventDefault();
        e.stopPropagation();
        const variantId = buyNowBtn.dataset.variantId;
        if (!variantId) return;

        const originalText = buyNowBtn.innerHTML;
        buyNowBtn.innerHTML = 'Redirecting…';
        buyNowBtn.disabled = true;

        try {
          await this.addItem(variantId, 1);
          window.location.href = '/checkout';
        } catch(err) {
          showToast('Kuch masla aaya, dobara try karo', 'error');
          buyNowBtn.innerHTML = originalText;
          buyNowBtn.disabled = false;
        }
        return;
      }

      const atcBtn = e.target.closest('.product-card__atc, .btn-atc');
      if (!atcBtn) return;
      e.preventDefault();
      e.stopPropagation();
      const variantId = atcBtn.dataset.variantId;
      if (!variantId) return;

      const originalText = atcBtn.innerHTML;
      atcBtn.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><polyline points="20 6 9 17 4 12"/></svg> Added!';
      atcBtn.style.background = '#2E7D32';
      atcBtn.disabled = true;

      try {
        await this.addItem(variantId, 1);
        showToast('✅ Cart mein add ho gaya!');
        this.open();
      } catch(err) {
        showToast('Kuch masla aaya, dobara try karo', 'error');
      } finally {
        setTimeout(() => {
          atcBtn.innerHTML = originalText;
          atcBtn.style.background = '';
          atcBtn.disabled = false;
        }, 1500);
      }
    });
  }

  open() {
    this.drawer?.classList.add('is-open');
    this.overlay?.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    this.fetchCart();
  }

  close() {
    this.drawer?.classList.remove('is-open');
    this.overlay?.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  async fetchCart() {
    try {
      const res = await fetch('/cart.js', { cache: 'no-store' });
      const cart = await res.json();
      this.renderCart(cart);
    } catch(e) { console.error('Cart fetch error:', e); }
  }

  async addItem(variantId, qty = 1) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: qty })
    });
    if (!res.ok) throw new Error('Add to cart failed');
    const data = await res.json();
    this.renderCart(data.items ? data : await (await fetch('/cart.js', { cache: 'no-store' })).json());
    return data;
  }

  async updateItem(key, qty) {
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      });
      const cart = await res.json();
      this.renderCart(cart);
    } catch(e) { console.error('Cart update error:', e); }
  }

  updateDeliveryBar(totalPrice) {
    const bar  = document.querySelector('.free-delivery-bar');
    const text = document.querySelector('.free-delivery-bar__text');
    const fill = document.querySelector('.free-delivery-bar__fill');
    if (!bar || !text || !fill) return;
    const remaining = this.FREE_THRESHOLD - totalPrice;
    const progress  = Math.min(100, Math.round(totalPrice * 100 / this.FREE_THRESHOLD));
    fill.style.width = progress + '%';
    if (remaining <= 0) {
      bar.classList.add('free-delivery-bar--done');
      text.innerHTML = '\u{1F389} You\'ve unlocked FREE delivery!';
    } else {
      bar.classList.remove('free-delivery-bar--done');
      const amt = 'Rs.' + (remaining / 100).toLocaleString('en-PK');
      text.innerHTML = 'Add <strong>' + amt + '</strong> more for FREE delivery';
    }
  }

  renderCart(cart) {
    const fmt = (n) => 'Rs. ' + (n / 100).toLocaleString('en-PK');
    const body        = document.querySelector('.cart-drawer__body');
    const totalEl     = document.querySelector('.cart-total .amount');
    const checkoutBtn = document.querySelector('.cart-checkout-btn');
    this.countEls.forEach(el => {
      el.textContent = cart.item_count;
      el.style.display = cart.item_count > 0 ? 'flex' : 'none';
    });
    if (totalEl)     totalEl.textContent     = fmt(cart.total_price);
    if (checkoutBtn) checkoutBtn.textContent = 'Checkout — ' + fmt(cart.total_price);
    this.updateDeliveryBar(cart.total_price);
    if (!body) return;
    if (cart.item_count === 0) {
      body.innerHTML = `
        <div class="cart-drawer__empty">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg>
          <p style="font-weight:600;margin-bottom:6px">Your bag is empty</p>
          <p style="font-size:13px">Add some beautiful lingerie!</p>
        </div>`;
      return;
    }
    body.innerHTML = cart.items.map(item => `
      <div class="cart-item" data-key="${item.key}">
        <div class="cart-item__img">
          <a href="${item.url}"><img src="${item.image}" alt="${item.title}" loading="lazy"></a>
        </div>
        <div class="cart-item__info">
          <div class="cart-item__title"><a href="${item.url}">${item.product_title}</a></div>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<div style="font-size:11px;color:#999;margin-bottom:4px">${item.variant_title}</div>` : ''}
          <div class="cart-item__price">${fmt(item.final_line_price)}</div>
          <div class="cart-item__qty">
            <button class="qty-btn" data-action="decrease" data-key="${item.key}" data-qty="${item.quantity}">−</button>
            <span class="qty-num">${item.quantity}</span>
            <button class="qty-btn" data-action="increase" data-key="${item.key}" data-qty="${item.quantity}">+</button>
          </div>
        </div>
      </div>`).join('');
    body.querySelectorAll('.qty-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        const key = btn.dataset.key;
        const qty = parseInt(btn.dataset.qty);
        const newQty = btn.dataset.action === 'increase' ? qty + 1 : Math.max(0, qty - 1);
        this.updateItem(key, newQty);
      });
    });
  }
}

// ===================== STICKY HEADER =====================
function initStickyHeader() {
  const header = document.querySelector('.site-header');
  if (!header) return;
  window.addEventListener('scroll', () => {
    header.classList.toggle('is-scrolled', window.scrollY > 80);
  }, { passive: true });
}

// ===================== WISHLIST (localStorage) =====================
const Wishlist = {
  key: 'mn_wishlist',
  get() { try { return JSON.parse(localStorage.getItem(this.key)) || []; } catch { return []; } },
  set(ids) { localStorage.setItem(this.key, JSON.stringify(ids)); },
  toggle(id) {
    const ids = this.get();
    const idx = ids.indexOf(id);
    if (idx > -1) { ids.splice(idx, 1); } else { ids.push(id); }
    this.set(ids);
    return idx === -1;
  },
  has(id) { return this.get().includes(id); }
};

function initWishlist() {
  document.querySelectorAll('.product-card__wishlist').forEach(btn => {
    const id = btn.dataset.productId;
    if (!id) return;
    if (Wishlist.has(id)) btn.classList.add('is-active');
    btn.addEventListener('click', () => {
      btn.classList.toggle('is-active', Wishlist.toggle(id));
    });
  });
}

// ===================== NOTIFICATION TOAST =====================
function showToast(msg, type = 'success') {
  let container = document.getElementById('mn-toast');
  if (!container) {
    container = document.createElement('div');
    container.id = 'mn-toast';
    container.style.cssText = 'position:fixed;bottom:80px;left:50%;transform:translateX(-50%);z-index:9999;pointer-events:none;width:90%;max-width:300px;';
    document.body.appendChild(container);
  }
  const el = document.createElement('div');
  el.style.cssText = `background:${type === 'success' ? '#2E7D32' : '#c0392b'};color:#fff;padding:13px 20px;border-radius:12px;font-size:14px;font-weight:600;box-shadow:0 6px 24px rgba(0,0,0,0.25);text-align:center;opacity:1;transition:opacity 0.4s;`;
  el.textContent = msg;
  container.appendChild(el);
  setTimeout(() => { el.style.opacity = '0'; setTimeout(() => el.remove(), 400); }, 2500);
}

// ===================== INIT =====================
document.addEventListener('DOMContentLoaded', () => {
  initAnnouncementBar();
  initSearch();
  initMobileMenu();
  initStickyHeader();
  initWishlist();
  document.querySelectorAll('.hero-slideshow').forEach(el => new HeroSlideshow(el));
  window.MNCart = new CartDrawer();
  window.showToast = showToast;
});
